///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/client-type.collection.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>

module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ProductWithCategoriesTemplate extends DataTemplateBase implements IDataTemplate {
        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        private _products: CollectionOptimizedApi<Model.Variant>;
        private _productCategories: CollectionOptimizedApi<Model.ProductCategory>;

        get collection() {
            return this._productCategories;
        }

        get leafCollection() {
            return this._products;
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this._products = new CollectionOptimizedApi(this.model[properties[0]], [], {
                url: 'productvariant',
                smartMoverHidden: () => this.smartMoverHidden,
            }, options.$scope);
            this._productCategories = new CollectionOptimizedApi(this.model[properties[1]], [], {
                CategoryModel: VirtualRepeatCategory,
                url: 'productCategory',
                smartMoverHidden: () => this.smartMoverHidden,
            }, options.$scope);

            this._products.setParentCollection(this._productCategories, CoreProductVariantToCategoryStrategy);

            const additionalCriteria = {
                includeNotForSale:  true    
            };
            this._products.updateCriteria(additionalCriteria);

            this.title = 'LABEL_PRODUCTS';
            this.allSelectedLabel = 'LABEL_ALL_PRODUCTS';
            this.totalSelectedMessage = 'LABEL_PRODUCTS_SELECTED';

            if (options.required) {
                this.validation.push(new RequiredValidation(this._products, 'LABEL_PRODUCTS_REQUIRED'));
            }
        }

        setWatchers(scope: angular.IScope) {
            this._productCategories.setWatchers(scope);

            super.setWatchers(scope);
        }
    }
}
